import { Component, Inject, OnInit } from "@angular/core";
import { NZ_MODAL_DATA } from "ng-zorro-antd/modal";


@Component({
    selector: 'webhook-debug-log-item',
    templateUrl: './webhook-debug-log-item.component.html',
    styleUrl: './webhook-debug-log-item.component.scss',
    standalone: false,
})

export class WebhookDebugLogItemComponent implements OnInit {
    
    ngOnInit(): void {
        
    }

    logJson:string = "[]";
    formattedJson:any;

    constructor( @Inject(NZ_MODAL_DATA) public nzData){
        
        if ( this.nzData['flowData']!=null && this.nzData['flowData']['resultList'] != null ){
            this.logJson = JSON.stringify(this.nzData['flowData']['resultList'],null,2);
        }
        
    }

    
}